// extracted by mini-css-extract-plugin
module.exports = {"navLink":"Navigation_navLink__gCTOn","activeNavLink":"Navigation_activeNavLink__1ak2U"};